import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import {
  EmailShareButton,
  FacebookShareButton,
  WhatsappShareButton,
} from 'react-share';
import Button from './core/Button';
import Modal from './Modals/Modal';
import styles from './ShareDialog.module.scss';

export interface Props {
  url: string;
  open: boolean;
  onClose: () => void;
}

export default function ShareDialog({ url, ...props }: Props) {
  const [linkCopied, setLinkCopied] = React.useState(false);

  const items = [
    {
      button: (
        <FacebookShareButton name="facebook" url={url}>
          <i className="fonticons fonticons-facebook" />
          Facebook
        </FacebookShareButton>
      ),
    },
    {
      button: (
        <WhatsappShareButton name="whatsapp" url={url}>
          <i className="fonticons fonticons-whatsapp" />
          Whatsapp
        </WhatsappShareButton>
      ),
    },
    {
      button: (
        <CopyToClipboard onCopy={() => setLinkCopied(true)} text={url}>
          <button>
            <i className="fonticons fonticons-copy" />
            {linkCopied ? 'Link Copiado' : 'Copiar Link'}
          </button>
        </CopyToClipboard>
      ),
    },
    {
      name: 'Email',
      button: (
        <EmailShareButton
          name="email"
          url={url}
          subject="Mira esta propiedad en Hauscanner!"
          body="Mira esta propiedad en Hauscanner!"
        >
          <i className="fonticons fonticons-email" />
          Email
        </EmailShareButton>
      ),
    },
  ];

  return (
    <Modal
      title="Comparte esta propiedad"
      open={props.open}
      onClose={props.onClose}
      footer={
        <Button
          style={{ float: 'right' }}
          label="CERRAR"
          onClick={props.onClose}
        />
      }
    >
      {items.map((el, idx) => (
        <div key={idx} className={styles.item}>
          {el.button}
        </div>
      ))}
    </Modal>
  );
}
